// class NewsletterSignup {
//   static init(...parameters) {
//     return new NewsletterSignup(...parameters);
//   }

//   constructor(block) {
//     console.log({ NewsletterSignup: block });
//   }
// }

// // Register class
// if (window.brix && window.brix.registerBlock) {
//   window.brix.registerBlock('brix-newsletter-signup', NewsletterSignup.init);
// }
